import { IModColor } from '@ucheba/utils/helpers/styles/mod.types'
import React from 'react'

export interface ITeacherCard {
  view?: keyof typeof ETeacherCardsViews
  subjects: {
    name: string
    iconUrl: string
    [key: string]: unknown
  }[]
  href?: string | null
  aboveNameText?: string | React.ReactNode
  name: string
  description: string[]
  buttonText?: string
  onClick?: () => void
  list?: ITeachersListItem[]
  previewImage: string
  previewImageSqure?: string
  avgScore: {
    text: string
    scoreText: string
  }
  experience: {
    text: string
    scoreText: string
  }
  width?: string
  withSubjects?: boolean
}

export interface ITeacherCardItem {
  subjects: {
    name: string
    iconUrl: string
    [key: string]: unknown
  }[]
  href?: string | null
  aboveNameText?: string
  name: string
  description: string[]
  buttonText?: string
  onClick?: () => void
  list?: ITeachersListItem[]
  previewImage: string
  previewImageSqure?: string
  avgScore: {
    text: string
    scoreText: string
  }
  experience: {
    text: string
    scoreText: string
  }
  width?: string
  withSubjects?: boolean
}

export enum ETeacherCardsViews {
  vertical = 'vertical',
  horizontal = 'horizontal',
  extra = 'extra',
}

export interface IUseTeachersListWithIcons {
  (list: ITeachersListItem[] | undefined): (ITeachersListItem & { Icon: string })[] | null
}

export interface ITeachersListItem extends IModColor {
  text: string
  iconName: string
}

export enum EIconName {
  university = 'university',
  scales = 'scales',
  graduationCap = 'graduationCap',
  listView = 'listView',
  search = 'search',
  like = 'like',
  bowTie = 'bowTie',
}

export type TIconName = keyof typeof EIconName
